import { render, staticRenderFns } from "./OrganizationExamRegister.vue?vue&type=template&id=97dce104&"
import script from "./OrganizationExamRegister.vue?vue&type=script&lang=js&"
export * from "./OrganizationExamRegister.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationExamRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports